/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AppImport } from './routes/_app'
import { Route as AppSettingsImport } from './routes/_app.settings'
import { Route as AppDashboardImport } from './routes/_app.dashboard'
import { Route as AppAccountsImport } from './routes/_app.accounts'
import { Route as authLoginImport } from './routes/(auth)/login'

// Create Virtual Routes

const AboutLazyImport = createFileRoute('/about')()
const IndexLazyImport = createFileRoute('/')()
const authResetPasswordLazyImport = createFileRoute('/(auth)/reset-password')()
const authLostPasswordLazyImport = createFileRoute('/(auth)/lost-password')()

// Create/Update Routes

const AboutLazyRoute = AboutLazyImport.update({
  path: '/about',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const authResetPasswordLazyRoute = authResetPasswordLazyImport
  .update({
    path: '/reset-password',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/reset-password.lazy').then((d) => d.Route),
  )

const authLostPasswordLazyRoute = authLostPasswordLazyImport
  .update({
    path: '/lost-password',
    getParentRoute: () => rootRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/lost-password.lazy').then((d) => d.Route))

const AppSettingsRoute = AppSettingsImport.update({
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)

const AppDashboardRoute = AppDashboardImport.update({
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)

const AppAccountsRoute = AppAccountsImport.update({
  path: '/accounts',
  getParentRoute: () => AppRoute,
} as any)

const authLoginRoute = authLoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginImport
      parentRoute: typeof rootRoute
    }
    '/_app/accounts': {
      id: '/_app/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AppAccountsImport
      parentRoute: typeof AppImport
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardImport
      parentRoute: typeof AppImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsImport
      parentRoute: typeof AppImport
    }
    '/(auth)/lost-password': {
      id: '/lost-password'
      path: '/lost-password'
      fullPath: '/lost-password'
      preLoaderRoute: typeof authLostPasswordLazyImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexLazyRoute,
  AppRoute: AppRoute.addChildren({
    AppAccountsRoute,
    AppDashboardRoute,
    AppSettingsRoute,
  }),
  AboutLazyRoute,
  authLoginRoute,
  authLostPasswordLazyRoute,
  authResetPasswordLazyRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/about",
        "/login",
        "/lost-password",
        "/reset-password"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/accounts",
        "/_app/dashboard",
        "/_app/settings"
      ]
    },
    "/about": {
      "filePath": "about.lazy.tsx"
    },
    "/login": {
      "filePath": "(auth)/login.tsx"
    },
    "/_app/accounts": {
      "filePath": "_app.accounts.tsx",
      "parent": "/_app"
    },
    "/_app/dashboard": {
      "filePath": "_app.dashboard.tsx",
      "parent": "/_app"
    },
    "/_app/settings": {
      "filePath": "_app.settings.tsx",
      "parent": "/_app"
    },
    "/lost-password": {
      "filePath": "(auth)/lost-password.lazy.tsx"
    },
    "/reset-password": {
      "filePath": "(auth)/reset-password.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
